import mixx from '../../../../mixin/mixin.js'


export default {
  mixins: [mixx],
  name: "tventas",
  data() {
    return {

      loading: false,
      loading_f: false,

      f_c: {
        desde: this.date_rest(this.currentdate(), -6),
        hasta: this.currentdate(),
        estado: false
      },
      tabla: {
        campos: [],
        meses: [],
        data: [],
        tarjetas: [],
      }


    };
  },

  mounted: function () {

    $('.box').boxWidget();

  },

  methods: {

    descargar() {

      this.to_excel_name2($("#dett").html(), 'dett', 'Análisis Costos');

    },
    consultar() {
      this.loading = true;

      this.$http
        .post('/SERVER/scd/estadisticas/', {
          'a': 'analisisCostosTer',
          'f': this.f_c
        }, {
          withCredentials: true
        })
        .then(response => {

          this.ventast_tabla = 0;
          if (response.data.status == 1) {

            this.tabla.meses = response.data.meses;
            this.data = response.data.data;
            this.tabla.campos = [];
            this.tabla.tarjetas = response.data.tarjetas;

            for (let index = 0; index < this.tabla.meses.length; index++) {

              this.tabla.campos.push("Cantidad de cupones");
              this.tabla.campos.push("Venta");
              this.tabla.campos.push("Ecash");
              this.tabla.campos.push("Arancel");
              this.tabla.campos.push("CFO");
            }

          }
          this.loading = false;
        });
    },

  }


};



// WEBPACK FOOTER //
// ./src/components/estadisticas/analisisCostosTerminal/tventas/tventas.js